import type { NitroFetchOptions } from 'nitropack'

const legislations = ['eidas', 'zertes'] as const
const identTypes = ['self'] as const

const identificationRepository = (fetch: CustomFetch) => {
  const repository = {
    async getCoverageInfo(srId?: string, legislation?: Legislation) {
      const urlParam = srId ?? legislation ?? ''
      if (!urlParam) return { isCovered: false }

      const { covered: isCovered } = await fetch<{ covered: boolean }>(`/v1/user/identification/payment/${urlParam}`)

      return { isCovered }
    },
    async getIdentMethod(srId: string, sid: string) {
      return await fetch<IdentMethod>(`/v3/signature-requests/${srId}/signatures/${sid}/ident-method`)
    },
  }

  for (const legislation of legislations) {
    for (const identType of identTypes) {
      const baseName = `${capitalize(legislation)}${capitalize(identType)}Ident`
      // if identTypes array gets extended, we need to pass identType as an argument to getIdentPath and extend getIdentPath to receive identType parameter
      const url = getIdentPath(legislation)

      repository[`create${baseName}`] = (srid?: string): Promise<{ identUrl: string }> => {
        const options: Pick<NitroFetchOptions<string>, 'method' | 'body'> = { method: 'POST' }
        if (srid) options.body = objectToSnakeCase({ signatureRequestId: srid })

        return fetch(url, options)
      }

      repository[`get${baseName}Info`] = () => fetch(url)

      repository[`delete${baseName}`] = (email: string) => fetch(url, { method: 'DELETE', body: { email } })
    }
  }

  return repository as IdentificationRepository
}

export default identificationRepository
